import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import DropdownContent from "./DropdownContent.model";
import styles from "./Dropdown.module.scss"; 
import combineClasses from "helpers/combine-classes";

const Dropdown: FunctionComponent<DropdownContent> = (props) => {
    const { setFormFieldsState, formFieldsState, setRequiredFieldsEach, requiredFieldsEach, setIsAlert, isAlert, resetFields } = props;
    const [fieldValue, setFieldValue] = useState("");
    const ref = useRef<HTMLSelectElement>(null);

    useEffect(() => {
        if (resetFields && ref.current) { ref.current.value = "", setFieldValue(""); }
    }, [resetFields]);

    const handleChange = (e: React.FormEvent<HTMLSelectElement>) => {
        const el = e.target as HTMLInputElement;

        const includesAlias = requiredFieldsEach.length > 0 ? requiredFieldsEach.includes(props.alias) : false;
        if (props.mandatory && el.value.length > 0 && !includesAlias) {
            setRequiredFieldsEach([...requiredFieldsEach, props.alias]);
        }

        if (props.mandatory && el.value.length === 0 && includesAlias) {
            setRequiredFieldsEach(requiredFieldsEach.filter(e => e !== props.alias));
            setIsAlert(true);
        }

        setFormFieldsState({ ...formFieldsState, [el.name]: el.value });
        if (ref.current) setFieldValue(ref.current.value);
    };

    console.log(props.preValues);

    const alertClass = !fieldValue && props.mandatory && isAlert ? styles.alert : undefined;

    return (
        <div className={styles.select_field}>
            <label>
                <div className={styles.label_wrapper}>
                    <span className={styles.label}>{props.caption}</span> {props.mandatory ? (<span className={styles.mandatory}>*</span>) : null}
                </div>
                <select onChange={handleChange} className={combineClasses([styles.dropdown, alertClass])} ref={ref} name={props.alias}>
                    <option value="">Select...</option>

                    {props.preValues?.map((option: any, index) => {
                        const value = option.value ?? option.caption ?? option.label ?? "";
                        const label = option.caption ?? option.label ?? option.value ?? "";

                        return (
                            <option key={value || index} value={value}>
                                {label}
                            </option>
                        );
                    })}
                </select>
            </label>
        </div>
    );
};

export default Dropdown;
